/* psnm-basket-upsell.js - 6 Oct 2026, basket C. Free delivery bar, delivery estimate and basket actions.
   The "Add to your order" product list and the floating panel surface are OFF (MM decision). What stays is
   the free delivery logic: THRESHOLD 4900 cents (EUR 49), flat delivery 695 cents below it.

   The bar, the Delivery row and the Total row are rendered by Liquid in snippets/cart.psnm-c.liquid at the
   top of the cart drawer and of the /cart page, so they take their space on first paint and never shift
   anything. This script only rewrites their text and fill width when the cart changes:
     cart:updated       theme event after a quantity change (detail.cart is the /cart/change.js state)
     cart:quantity, cart:build, ajaxProduct:added, cart:open, pageshow  ->  debounced /cart.js read
   It also wires three small actions the theme does not handle:
     Remove link [data-psnm-cc-remove] and a stepper taken down to 0 -> /cart/change.js quantity 0
     "Often added" Add button [data-psnm-cc-add] -> /cart/add.js, then the theme's ajaxProduct:added event
   Keeps the psnm-drawer-open body class (psnm-basket-mobile.css hides floating buttons over the express
   checkout buttons while the drawer is open).
   Revert: restore assets/psnm-basket-upsell.bak-6oct2026.js. */
(function(){
  var THRESHOLD = 4900;
  var FLAT = 695;
  var DEBOUNCE = 300;
  var timer = null, seq = 0;

  function money(c){ return '€' + (c / 100).toFixed(2); }
  function all(sel){ return Array.prototype.slice.call(document.querySelectorAll(sel)); }

  function apply(cart){
    if(!cart || typeof cart.total_price !== 'number') return;
    var total = cart.total_price;
    var remaining = THRESHOLD - total;
    var pct = Math.max(0, Math.min(100, Math.floor(total * 100 / THRESHOLD)));
    var free = remaining <= 0;
    all('[data-psnm-cc-ship]').forEach(function(el){
      el.setAttribute('data-state', free ? 'free' : 'below');
      var msg = el.querySelector('[data-psnm-cc-ship-msg]');
      if(msg) msg.textContent = free ? 'You get free delivery on this order.' : ('You are ' + money(remaining) + ' from free delivery.');
      var fill = el.querySelector('[data-psnm-cc-ship-fill]');
      if(fill) fill.style.width = pct + '%';
    });
    all('[data-psnm-cc-delivery]').forEach(function(el){ el.textContent = free ? 'Free' : money(FLAT); });
    all('[data-psnm-cc-total]').forEach(function(el){ el.textContent = money(free ? total : total + FLAT); });
  }

  function refresh(){
    var mine = ++seq;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function(r){ return r.json(); })
      .then(function(cart){ if(mine === seq) apply(cart); })
      .catch(function(){});
  }

  function schedule(){ clearTimeout(timer); timer = setTimeout(refresh, DEBOUNCE); }

  function removeLine(key, el){
    if(el) el.classList.add('is-loading');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: 0, sections: 'cart-ajax' })
    })
      .then(function(r){ if(!r.ok) throw r; return r.json(); })
      .then(function(state){
        // Last line gone on the cart page: reload so the theme shows its empty basket state.
        if(state.item_count === 0 && document.getElementById('CartPageForm')){ window.location.reload(); return; }
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: state } }));
        document.dispatchEvent(new CustomEvent('cart:build'));
      })
      .catch(function(){ window.location.href = '/cart/change?id=' + encodeURIComponent(key) + '&quantity=0'; });
  }

  document.addEventListener('click', function(e){
    var rm = e.target.closest && e.target.closest('[data-psnm-cc-remove]');
    if(rm){
      e.preventDefault();
      removeLine(rm.getAttribute('data-psnm-cc-remove'), rm.closest('.cart__item'));
      return;
    }
    var add = e.target.closest && e.target.closest('[data-psnm-cc-add]');
    if(add){
      e.preventDefault();
      if(add.disabled) return;
      var vid = parseInt(add.getAttribute('data-psnm-cc-add'), 10);
      if(!vid) return;
      add.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id: vid, quantity: 1 }], sections: 'cart-ajax' })
      })
        .then(function(r){ if(!r.ok) throw r; return r.json(); })
        .then(function(res){
          // Same event the theme's own add to cart fires: the drawer, the cart page and the header count rebuild from it.
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: res, preventCartOpen: true } }));
          all('[data-psnm-cc-often]').forEach(function(b){ b.hidden = true; });
        })
        .catch(function(){ add.disabled = false; });
    }
  });

  // The theme ignores a stepper taken down to 0 (CartForm returns early on qty 0). Treat it as Remove.
  document.addEventListener('cart:quantity', function(e){
    var d = e.detail;
    if(d && d[0] && d[1] === 0){ removeLine(d[0], d[2] && d[2].closest ? d[2].closest('.cart__item') : null); return; }
    schedule();
  });

  document.addEventListener('cart:updated', function(e){
    var c = e.detail && e.detail.cart;
    if(c && typeof c.total_price === 'number'){ seq++; apply(c); } else schedule();
  });
  ['cart:build', 'ajaxProduct:added'].forEach(function(ev){ document.addEventListener(ev, schedule); });

  // Cap the drawer's single scrolling column at the visible viewport so its bottom is always reachable.
  function fitDrawer(){
    var f = document.querySelector('header-cart-drawer .cart__drawer-form'); if(!f) return;
    var top = f.getBoundingClientRect().top;
    if(top < 0 || top > window.innerHeight) return;
    f.style.setProperty('--psnm-cc-drawer-max', Math.max(320, Math.floor(window.innerHeight - top - 12)) + 'px');
  }
  var fitTimer = null;
  function scheduleFit(){ clearTimeout(fitTimer); fitTimer = setTimeout(fitDrawer, 60); }
  window.addEventListener('resize', scheduleFit);

  document.addEventListener('cart:open', function(){ document.body.classList.add('psnm-drawer-open'); schedule(); scheduleFit(); setTimeout(fitDrawer, 450); });
  document.addEventListener('cart:close', function(){ document.body.classList.remove('psnm-drawer-open'); });
  document.addEventListener('headerDrawer:closed', function(){ document.body.classList.remove('psnm-drawer-open'); });
  window.addEventListener('pageshow', function(e){ if(e.persisted) schedule(); });
})();
